
import React, { createContext, ReactNode, useContext, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { initializeApp } from 'firebase/app';
import { getMessaging, getToken, onMessage } from "firebase/messaging";

import History from '../Helpers/History'
import { isWebToNativeDevice } from "@/Helpers/MobileHelper";

import { useAuth } from "./UseAuth";

import NotificationsService from "@/Services/NotificationsService";


interface ContextValue {
  token: string | undefined;
  notifications: any[];
  notification: any;
}

const NotificationsContext = createContext<ContextValue | undefined>(undefined);

export const NotificationsProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();

  const { isAuthenticated } = useAuth()

  const pathname = window.location.pathname;

  const isNotificationRoute = pathname.split('/')[1] === 'notification'
  const notification_id = pathname.split('/')[2]

  const [ isMobile, setIsMobile ] = useState<boolean>(false)
  const [ token, setToken ] = useState<string | undefined>()

  const [ notifications, setNotifications ] = useState<any[]>([])
  const [ notification, setNotification ] = useState<any>()

  const loadNotification = async () => {

    const { data, error } = await NotificationsService.getNotification(notification_id)

    if (error) return console.log(error)

    setNotification(data)
  }

  const value: ContextValue = {
    token,
    notifications,
    notification,
  }

  // check is mobile or desktop
  useEffect(() => {
    const checkIsMobile = async () => {
      const isMobile = await isWebToNativeDevice()

      setIsMobile(isMobile)
    }

    checkIsMobile()
  }, [])

  // initialize firebase
  useEffect(() => {
    const initializeFirebase = async () => {
      const firebaseConfig = {
        apiKey: "AIzaSyBxi6XZkBcDO9hHlw0pCc7ZaQrsCtIkLfY",
        authDomain: "pl4nner-notifications-test.firebaseapp.com",
        projectId: "pl4nner-notifications-test",
        storageBucket: "pl4nner-notifications-test.firebasestorage.app",
        messagingSenderId: "210181620184",
        appId: "1:210181620184:web:f8f6e1655a49bc8a9672ad",
        measurementId: "G-3Q24DL12NZ"
      };

      const app = await initializeApp(firebaseConfig)

      const messaging = getMessaging(app);

      Notification.requestPermission().then(function (permission) {
        if (permission === "granted") {
            getToken(messaging, { vapidKey: "BFfinEJa1ILQuBplM3mEoG2BILdPLE2pmVpbYvBS3796gf71oF2Ehjse-6B5znzccW7AgD2WU1vIrMeHpc-Ip9E" })
              .then(async (token) => {

                if (token) {

                  setToken(token)

                  if (isAuthenticated) {

                    await NotificationsService.saveFCMToken(token)
                  }
                }
              });
          }
      });

      onMessage(messaging, (payload) => {

        const { title, body } = payload.data as any;

        const notification = new Notification(title, {
          body,
          data: payload.data, // 👈 importante para el click
        });

        notification.onclick = (event) => {
          notification.close();

          const { type, project, team, task, chat } = notification.data;

          let url = '/'

          switch (type) {
            case 'team_invitation':
            case 'project_delegation':
            case 'assistant_assignment':
            case 'assistant_unassignment':
            case 'account_deleted_by_user':
              url = `/project/${project}`;
              break;
            case 'project_abandonment':
              url = `/project/${project}/teams`;
              break;
            case 'team_member_addition':
            case 'team_member_moved':
              url = `/project/${project}/teams/${team}`;
              break;
            case 'task_creation':
            case 'task_assignment':
            case 'task_unassignment':
            case 'task_confirmed':
            case 'task_rejected':
              url = `/project/${project}/programmation-macro?task_id=${task}`;
              break;
            case 'task_deletion':
              url = `/project/${project}/programmation-macro`;
              break;
            case 'chat_addition':
            case 'chat_message':
              url = `/chat/${chat}`
              break;
            default:
              url = '/'
              break
          }

          History.push(url);
        };
      });
    }

    initializeFirebase()
  }, [])

  useEffect(() => {

    if (isNotificationRoute) {

      loadNotification()
    }
  }, [isNotificationRoute])

  return (
    <NotificationsContext.Provider value={value}>
      {children}
    </NotificationsContext.Provider>
  );
}

export const useNotifications = (): ContextValue => {

  const context = useContext(NotificationsContext);

  if (context === undefined) {

    throw new Error("useNotifications must be used within a NotificationsProvider");
  }

  return context;
}
